import { ChakraProvider } from '@chakra-ui/react';

import { ColorModeProvider, ColorModeProviderProps } from 'ui/ColorMode';
import Toaster from 'ui/Toaster';
import system from 'ui/system';

const Provider: React.FC<ColorModeProviderProps> = (props) => (
  <ChakraProvider value={system}>
    {/* Force theme to be light for now (https://www.chakra-ui.com/docs/styling/dark-mode) */}
    <ColorModeProvider enableSystem={false} {...props} />
    <Toaster />
  </ChakraProvider>
);

export default Provider;
